import { useEffect, useRef, useState } from "react";

export default function useAiOrbAnimation() {

    const orbRef = useRef(null);

    const [expanded, setExpanded] = useState(false);

    const [hovered, setHovered] = useState(false);

    const [style, setStyle] = useState({});

    /* ---------------------------------- */
    /* Auto Expand                        */
    /* ---------------------------------- */

    useEffect(() => {

        const interval = setInterval(() => {

            setExpanded(true);

            const timer = setTimeout(() => {

                setExpanded(false);

            }, 2600);

            return () => clearTimeout(timer);

        }, 7500);

        return () => clearInterval(interval);

    }, []);

    /* ---------------------------------- */
    /* Magnetic Hover                     */
    /* ---------------------------------- */

    useEffect(() => {

        const element = orbRef.current;

        if (!element) return;

        const handleMove = (event) => {

            const rect = element.getBoundingClientRect();

            const x = event.clientX - rect.left;

            const y = event.clientY - rect.top;

            const centerX = rect.width / 2;

            const centerY = rect.height / 2;

            const moveX = (x - centerX) * 0.12;

            const moveY = (y - centerY) * 0.12;

            setStyle({
                transform: `translate(${moveX}px, ${moveY}px) scale(1.04)`
            });

        };

        const handleLeave = () => {

            setStyle({
                transform: "translate(0px,0px) scale(1)"
            });

        };

        element.addEventListener("mousemove", handleMove);

        element.addEventListener("mouseleave", handleLeave);

        return () => {

            element.removeEventListener(
                "mousemove",
                handleMove
            );

            element.removeEventListener(
                "mouseleave",
                handleLeave
            );

        };

    }, []);

    return {

        orbRef,

        expanded,

        hovered,

        setHovered,

        style

    };

}